import { SHOW_ALERT_MSG } from '../actions/actionTypes';

const initialState = {
    type: '',
    description: null,
    message: null
};

export const alertReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_ALERT_MSG: {
            const newState = Object.assign({}, state, action.config);
            return newState;
        }
        default: {
            return state;
        }
    }
}